import axios from "axios";
import { useEffect, useState } from "react";
import { useBrandingContext } from "../../../../../components/BrandingContext";
import Swal from "sweetalert2";
import { initialModification } from "../../const";

export const useMyBooking = () => {
  const [branding, setBranding] = useState(null);
  const [bookingId, setBookingId] = useState("");
  const [transactionId, setTransactionId] = useState("");
  const [bookingDetails, setBookingDetails] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [modification, setModification] = useState(initialModification);

  const { branding: ctxBranding } = useBrandingContext();

  useEffect(() => {
    if (ctxBranding) setBranding(ctxBranding);
  }, [ctxBranding]);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const bookingIdFromURL = urlParams.get("bookingId");
    const transactionIdFromURL = urlParams.get("transactionId");

    if (bookingIdFromURL) setBookingId(bookingIdFromURL);
    if (transactionIdFromURL) setTransactionId(transactionIdFromURL);
  }, []);

  const validateBooking = async () => {
    setIsLoading(true);
    try {
      const response = await axios.post("/api/bookings/validatebooking", {
        bookingId,
        transactionId,
      });
      if (response.data.valid) {
        const bookingResponse = await axios.get(
          `/api/bookings/getBookingById?orderId=${bookingId}`
        );
        setBookingDetails(bookingResponse.data.booking);
        setModification({
          guestName: bookingResponse.data.booking.guestName,
          guestEmail: bookingResponse.data.booking.guestEmail,
          guestNationality: bookingResponse.data.booking.guestNationality,
          specialRequest: bookingResponse.data.booking.specialRequest,
        });
        Swal.fire("Success!", "Booking validated successfully!", "success");
      } else {
        Swal.fire("Error!", "Invalid booking ID or transaction ID.", "error");
      }
    } catch (err) {
      Swal.fire(
        "Error!",
        "An error occurred while validating the booking. Check your both Booking Id and Transaction Id again",
        "error"
      );
    }
    setIsLoading(false);
  };

  const modifyBooking = async () => {
    setIsLoading(true);
    try {
      setIsLoading(false);
      await axios.post("/api/bookings/modify", { bookingId, ...modification });
      Swal.fire("Success!", "Booking modified successfully!", "success");
    } catch (err) {
      setIsLoading(false);
      Swal.fire("Error!", "Failed to modify the booking.", "error");
    }
  };

  const cancelBooking = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You will not be able to recover this booking!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, cancel it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await axios.post("/api/bookings/cancelbooking", {
            bookingid: bookingId,
          });
          Swal.fire("Canceled!", "Your booking has been canceled.", "success");
          setBookingDetails(null); // Reset booking details
        } catch (err) {
          Swal.fire("Error!", "Failed to cancel the booking.", "error");
        }
      }
    });
  };

  return {
    branding,
    bookingId,
    transactionId,
    bookingDetails,
    isLoading,
    modification,
    setModification,
    validateBooking,
    modifyBooking,
    cancelBooking,
    setTransactionId,
    setBookingId,
  };
};
